import Table from "react-bootstrap/Table";

import { ResumeGrouped } from "@/services/esus/attendanceService";
import { GrievanceNotification } from "@/@types/sintegrada/GrievanceNotification";

import { TableSkeletons } from "@/components/TableSkeletons";

type Props = {
	groupedByGrievanceNotification: ResumeGrouped<GrievanceNotification, object>[];
	isLoading: boolean;
};

export function GrievanceNotificationTable({ groupedByGrievanceNotification, isLoading }: Props) {
	return (
		<Table responsive className="bg-white" bordered hover>
			<thead className="fw-bolder">
				<tr>
					<th className="ps-2">Notificação</th>
					<th className="text-center">Total</th>
				</tr>
			</thead>
			<tbody>
				{groupedByGrievanceNotification && !isLoading ? (
					groupedByGrievanceNotification?.map((item, index) => (
						<tr key={`grouped-by-grievance-notification-${index}`}>
							<td title="Notificação" className="ps-2">
								{item.key.name}
							</td>
							<td title="Total" className="text-center">
								{item.total.toLocaleString()}
							</td>
						</tr>
					))
				) : (
					<TableSkeletons numberOfCells={2} numberOfRows={10} />
				)}
			</tbody>
		</Table>
	);
}
